var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailWings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.376,
    height: 25.182,
    x: 11.312,
    y: 0.52,
    stroke: "#000",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#000",
    points: "11.312 4.117 27.5 13.11 43.688 4.117"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M43.6882267 5.91569767L54.4803779.519622093C54.4803779 20.3052326 43.6882267 18.5065407 43.6882267 18.5065407M11.3117733 5.91569767L.519622093.519622093C.519622093 20.3052326 11.3117733 18.5065407 11.3117733 18.5065407"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#30881C",
    d: "M27.5 36.4934593L27.5 54.4803779M36.4934593 32.8960756L36.4934593 43.6882267M18.5065407 32.8960756L18.5065407 43.6882267"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWings);
export default __webpack_public_path__ + "assets/media/mail-wings.579650eb4581de258d460329a6fbbe2d.svg";
export { ForwardRef as ReactComponent };